import { Outlet } from 'react-router-dom';
import { useInviteContext } from '../../hooks/useInviteContext';
import { useOnboardingSignUpGate } from '../../hooks/useOnboardingSignUpGate';
import { OnboardingFlowErrorScreen } from './OnboardingFlowErrorScreen';
import { OnboardingFlowLoadingScreen } from './OnboardingFlowLoadingScreen';

/** Resolves sign-up id; pre-auth uses invite callable only, post-auth waits for `signedUpPatients` listener. */
export function OnboardingSignUpGateLayout() {
  useInviteContext();
  const gate = useOnboardingSignUpGate();

  if (gate.status === 'hydrating' || gate.status === 'loading_patient') {
    return <OnboardingFlowLoadingScreen />;
  }

  if (gate.status === 'error') {
    return <OnboardingFlowErrorScreen reason={gate.reason} />;
  }

  return <Outlet />;
}
